'use client';

import Image from 'next/image';
import amazonPng from '../../assets/images/rewards-program/amazon.png';
import cakePng from '../../assets/images/rewards-program/cake.png';
import datePng from '../../assets/images/rewards-program/date.png';

import messagePng from '../../assets/images/rewards-program/message.png';
import sharePng from '../../assets/images/rewards-program/share.png';
import shippingCartPng from '../../assets/images/rewards-program/shipping-cart.png';
import signInPng from '../../assets/images/rewards-program/sign-in.png';
import succeedPng from '../../assets/images/rewards-program/succeed.png';
import writePng from '../../assets/images/rewards-program/write.png';

import { useUserContext } from '@/context/user';
import { useToasts } from '@/hooks/Toasts';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { useMutation } from '@apollo/client';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { AlertCircle, Check } from 'react-feather';
import {
  GET_CUSTOMER_INFORMATION,
  SET_CUSTOMER_INFORMATION,
} from '../AccountInformationPage/accountInformationPage.gql';
import BirthdayInputModal from './birthdayInputModal';
import { DAILY_CHECK_IN, GET_CUSTOMER_REWARDS_BALANCE, REDEEM_ORDER_POINT } from './gql';
import RedeemAmazonOrderModal from './redeemAmazonOrderModal';
import RedeemModal from './redeemModal';
import SharePurchaseLinkModal from './sharePurchaseLinkModal';
import ShareSignUpLinkModal from './shareSignUpLinkModal';
import SignTip from './signTip';

const ENUM_VISIBLE_MODAL = {
  NONE: 0,
  AMAZON_ORDER_INPUT: 1,
  BIRTHDAY_INPUT: 2,
  SHARE_SIGN_UP_LINK: 3,
  SHARE_PURCHASE_LINK: 4,
};

const initRedeemInfoState = () => ({
  open: false,
  type: '',
  title: '',
  description: '',
  confirmText: '',
});

const Interaction = props => {
  const { operationAvailableMap, birthDay, shareCode } = props;
  const [{ isSignedIn }] = useUserContext();
  const [visibleModal, setVisibleModal] = useState(ENUM_VISIBLE_MODAL.NONE);
  const [, { addToast }] = useToasts();
  const router = useRouter();
  const { isMobile } = useIsMobile();
  const [redeemModalInfo, setRedeemModalInfo] = useState(initRedeemInfoState);

  const [reqDailyCheckIn, { loading: dailyCheckInLoading }] = useMutation(DAILY_CHECK_IN, {
    onCompleted: data => {
      if (String(data.dailyCheckIn.code) === '200') {
        setVisibleModal(ENUM_VISIBLE_MODAL.NONE);
        setRedeemModalInfo({
          open: true,
          type: 'succeed',
          title: 'CHECK-IN SUCCEED',
          description: 'You Have Earned 10 Points!',
          confirmText: 'SOUNDS GREAT !',
        });
      } else {
        showToast(data.dailyCheckIn.content, 'error');
      }
    },
    onError: err => {
      const errContent = err.networkError.result?.content || err.message;

      showToast(errContent, 'error');
    },
    errorPolicy: 'all',
    refetchQueries: [GET_CUSTOMER_INFORMATION, GET_CUSTOMER_REWARDS_BALANCE],
  });

  const [reqRedeemAmazonOrder, { loading: redeemAmazonOrderLoading }] = useMutation(REDEEM_ORDER_POINT, {
    onCompleted: data => {
      if (String(data.redeem.code) === '200') {
        setVisibleModal(ENUM_VISIBLE_MODAL.NONE);
        setRedeemModalInfo({
          open: true,
          type: 'succeed',
          title: 'REDEEMED!',
          description: 'You Have Successfully Redeemed The Points!',
          confirmText: 'SHOP NOW',
        });
      } else {
        setRedeemModalInfo({
          open: true,
          type: 'failed',
          title: data.redeem.content,
          description: 'Please Check And Re-Enter.',
          confirmText: 'CONFIRM',
          cancelText: 'CANCEL',
        });
      }
    },
    onError: err => {
      const errContent = err.networkError.result?.content || err.message;

      setRedeemModalInfo({
        open: true,
        type: 'failed',
        title: errContent,
        description: 'Please Check And Re-Enter.',
        confirmText: 'CONFIRM',
        cancelText: 'CANCEL',
      });
    },
    errorPolicy: 'all',
    refetchQueries: [GET_CUSTOMER_INFORMATION, GET_CUSTOMER_REWARDS_BALANCE],
  });
  const [reqSetCustomerInformation, { loading: isSetCustomerInformationLoading }] = useMutation(
    SET_CUSTOMER_INFORMATION,
    {
      errorPolicy: 'all',
      onCompleted: () => {
        setVisibleModal(ENUM_VISIBLE_MODAL.NONE);
        setRedeemModalInfo({
          open: true,
          type: 'succeed',
          title: 'REGISTER SUCCEED',
          description: 'Points will be issued on your birthday!',
          confirmText: 'SOUNDS GREAT !',
        });
      },
      onError: err => {
        const errContent = err.networkError.result?.content || err.message;

        showToast(errContent, 'error');
      },
      refetchQueries: [GET_CUSTOMER_INFORMATION, GET_CUSTOMER_REWARDS_BALANCE],
    },
  );

  const handleAmazonOrderModalOk = orderNumber => {
    reqRedeemAmazonOrder({
      variables: {
        ordernumber: orderNumber,
        platform: 'amazon',
      },
    });
  };

  const showToast = (message, type) => {
    let icon;

    if (type === 'success') {
      icon = <Check />;
    } else if (type === 'error') {
      icon = <AlertCircle />;
    }

    addToast({
      type,
      icon,
      message,
      timeout: 5000,
    });
  };

  const handleMobileCardClick = cardConfig => {
    if (!isMobile) {
      return;
    }

    if (!isSignedIn) {
      router.push('/sign-in');

      return;
    }

    if (!cardConfig.available) {
      return;
    }

    cardConfig.btnOnClick?.();
  };

  const interactionConfigs = [
    {
      icon: (
        <Image
          src={signInPng}
          alt='sign-in'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'CREATE AN ACCOUNT',
      pointDesc: '100 Points',
    },
    {
      icon: (
        <Image
          src={shippingCartPng}
          alt='shipping-cart'
          width={42}
          height={41}
          className='w-7 lg_w-10'
        />
      ),
      title: 'PURCHASE',
      pointDesc: '$1 = 1 Point',
      btnText: (
        <Link
          className='flex h-full w-full items-center justify-center'
          href='/bird-feeders'
        >
          SHOP NOW
        </Link>
      ),
      btnOnClick: () => {
        router.push('/bird-feeders');
      },
      available: true,
    },
    {
      icon: (
        <Image
          src={amazonPng}
          alt='amazon'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: (
        <>
          <div>AMAZON ORDER</div>
          <div>REDEEM</div>
        </>
      ),
      pointDesc: '$1 = 1 Point',
      btnText: 'REDEEM NOW',
      loading: redeemAmazonOrderLoading,
      btnOnClick: async () => {
        if (redeemAmazonOrderLoading) {
          return;
        }

        setVisibleModal(ENUM_VISIBLE_MODAL.AMAZON_ORDER_INPUT);
      },
      available: true,
    },
    {
      icon: (
        <Image
          src={sharePng}
          alt='share'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: (
        <>
          <div>REFER A FRIEND</div>
          <div>SIGN UP</div>
        </>
      ),
      pointDesc: '100 Points',
      btnText: 'REFER NOW',
      btnOnClick: () => {
        setVisibleModal(ENUM_VISIBLE_MODAL.SHARE_SIGN_UP_LINK);
      },
      available: operationAvailableMap.refer_a_friend_sign_up,
    },
    {
      icon: (
        <Image
          src={sharePng}
          alt='share'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: (
        <>
          <div>REFER A FRIEND</div>
          <div>PURCHASE</div>
        </>
      ),
      pointDesc: '500 Points',
      btnText: 'REFER NOW',
      btnOnClick: () => {
        setVisibleModal(ENUM_VISIBLE_MODAL.SHARE_PURCHASE_LINK);
      },
      available: operationAvailableMap.refer_a_friend_purchase,
    },
    {
      icon: (
        <Image
          src={cakePng}
          alt='cake'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'BIRTHDAY GIFT',
      pointDesc: 'depends on level',
      btnText: 'ADD BIRTHDAY',
      loading: isSetCustomerInformationLoading,
      btnOnClick: async () => {
        if (isSetCustomerInformationLoading) {
          return;
        }

        setVisibleModal(ENUM_VISIBLE_MODAL.BIRTHDAY_INPUT);
      },
      available: !birthDay,
      birthDay,
    },
    {
      icon: (
        <Image
          src={datePng}
          alt='date'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'DAILY CHECK-IN',
      pointDesc: '10 Points',
      btnText: 'CHECK IN',
      loading: dailyCheckInLoading,
      btnOnClick: async () => {
        if (dailyCheckInLoading) {
          return;
        }

        reqDailyCheckIn();
      },
      available: operationAvailableMap.daily_check_in,
    },
    {
      icon: (
        <Image
          src={messagePng}
          alt='message'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'LEAVE A REVIEW',
      pointDesc: '20 Points',
      btnText: (
        <Link
          className='flex h-full w-full items-center justify-center'
          href='/bird-feeders'
        >
          REVIEW NOW
        </Link>
      ),
      btnOnClick: () => {
        router.push('/bird-feeders');
      },
      available: true,
    },
    {
      icon: (
        <Image
          src={writePng}
          alt='write'
          width={40}
          height={40}
          className='w-7 lg_w-10'
        />
      ),
      title: 'FEEDBACK WEBSITE',
      pointDesc: '20 Points',
      btnText: (
        <Link
          className='flex h-full w-full items-center justify-center'
          href='/customer-feedback'
        >
          WRITE NOW
        </Link>
      ),
      btnOnClick: () => {
        router.push('/customer-feedback');
      },
      available: operationAvailableMap.feedback_website,
    },
  ];

  return (
    <div className={props.className}>
      <div className='text-center text-sm font-normal leading-5 text-title lg_text-[20px] lg_leading-[22px]'>
        ENGAGE IN INTERACTION
      </div>

      <div
        className={clsx(
          'mx-2.5 mt-[30px]  max-w-[1440px]  min-[1440px]_mx-auto',
          'grid grid-cols-[repeat(2,170px)] gap-x-[15px] gap-y-[15px] sm_grid-cols-[repeat(3,170px)] lg_grid-cols-[repeat(3,260px)] lg_gap-x-[35px] min-[1200px]_grid-cols-5',
          'justify-center justify-items-center',
        )}
      >
        {interactionConfigs.map((x, i) => {
          return (
            <div
              key={i}
              className={clsx(
                'relative h-[180px] w-full max-w-[170px] overflow-hidden rounded-[10px] lg_h-[300px]  lg_max-w-[260px]  ',
                'border-[2px] border-solid border-[#efefef] lg_border-[3px]',
                isSignedIn
                  ? (x.available === false || i === 0) && 'bg-[#efefef] lg_bg-[transparent]'
                  : 'group lg_hover_border-none',
              )}
              onClick={() => {
                handleMobileCardClick(x);
              }}
            >
              <div
                className={clsx(
                  'mt-[25px] flex justify-center ',
                  isSignedIn && i !== 0 && x.available ? 'lg_mt-[25px]' : 'lg_mt-[75px]',
                )}
              >
                {x.icon}
              </div>

              <div className='mt-2.5 text-center text-sm font-normal leading-5 text-title lg_text-lg lg_leading-[22px]'>
                {isSignedIn && i === 0 ? (
                  <>
                    <div>YOU HAVE CREATED</div>
                    <div>AN ACCOUNT</div>
                  </>
                ) : (
                  x.title
                )}
              </div>

              {x.birthDay ? (
                <div className='  mx-auto mt-4 hidden text-center font-sans text-base font-normal lg_block'>
                  {x.birthDay}
                </div>
              ) : null}

              <div
                className={clsx(
                  'flex items-center justify-center',
                  'absolute bottom-[35px] w-full text-center font-sans text-base font-bold leading-5 text-title lg_text-[18px] lg_font-semibold',
                  isSignedIn && i !== 0 && x.available ? 'lg_bottom-[125px]' : 'lg_bottom-[75px]',
                )}
              >
                {((isSignedIn && i === 0) || (isSignedIn && x.available === false)) && (
                  <Image
                    src={succeedPng}
                    alt='checked'
                    width={14}
                    className={clsx('lg_hidden')}
                    height={12}
                  />
                )}
                <span className={clsx(isSignedIn && x.available === false && 'ml-[5px] lg_ml-0')}>{x.pointDesc}</span>
              </div>

              {isSignedIn && x.btnText && x.available ? (
                <button
                  className={clsx(
                    'absolute bottom-[30px] left-0 right-0 mx-7 hidden h-[60px] lg_block',
                    'text-center text-base font-normal leading-5 text-primary',
                    'bg-[#EFEFEF] active_scale-[.97] disabled_scale-100',
                    'hover_bg-primary hover_text-white',
                  )}
                  onClick={e => {
                    e.stopPropagation();
                    x.btnOnClick?.();
                  }}
                  disabled={x.loading}
                >
                  {x.loading ? `${x.btnText}...` : x.btnText}
                </button>
              ) : null}

              {isSignedIn ? null : <SignTip className={clsx('group-hover_lg_block')} />}
            </div>
          );
        })}
      </div>

      <RedeemAmazonOrderModal
        open={visibleModal === ENUM_VISIBLE_MODAL.AMAZON_ORDER_INPUT}
        onCancel={() => {
          setVisibleModal(ENUM_VISIBLE_MODAL.NONE);
        }}
        onOk={handleAmazonOrderModalOk}
        confirmLoading={redeemAmazonOrderLoading}
      />

      <BirthdayInputModal
        open={visibleModal === ENUM_VISIBLE_MODAL.BIRTHDAY_INPUT}
        onCancel={() => {
          setVisibleModal(ENUM_VISIBLE_MODAL.NONE);
        }}
        confirmLoading={isSetCustomerInformationLoading}
        onOk={birthday => {
          reqSetCustomerInformation({
            variables: {
              customerInput: {
                date_of_birth: birthday,
              },
            },
          });
        }}
      />
      <ShareSignUpLinkModal
        open={visibleModal === ENUM_VISIBLE_MODAL.SHARE_SIGN_UP_LINK}
        onCancel={() => {
          setVisibleModal(ENUM_VISIBLE_MODAL.NONE);
        }}
        shareCode={shareCode}
      />
      <SharePurchaseLinkModal
        open={visibleModal === ENUM_VISIBLE_MODAL.SHARE_PURCHASE_LINK}
        onCancel={() => {
          setVisibleModal(ENUM_VISIBLE_MODAL.NONE);
        }}
        shareCode={shareCode}
      />

      <RedeemModal
        onCancel={() => {
          setRedeemModalInfo(initRedeemInfoState);
        }}
        onOk={() => {
          if (String(redeemModalInfo.confirmText).toUpperCase() === 'SHOP NOW') {
            router.push('/bird-feeders');
          }

          setRedeemModalInfo(initRedeemInfoState);
        }}
        {...redeemModalInfo}
      />
    </div>
  );
};

export default Interaction;
